import React from 'react';
import {
  withSystem,
  Atom,
  type AtomRenderProps,
  Types,
} from '@packages/systems/wfdl';
import {extraAtomFields} from '@packages/shared/constants/Atoms';

import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';

const FormFileUploadError = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const errorState = context.get('formFileUploadState') === 'error';
    const updatedClasses = classes.push(
      errorState ? 'w-file-upload-error' : 'w-file-upload-error w-hidden'
    );

    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [{is: 'FormFileUploadErrorMsg', rule: 'ExactlyOne'}],
  },
  render: FormFileUploadError,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          tabIndex: withSystem({defaultValue: '-1'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
});

export default config;
